module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-search"
  }, [_c('div', {
    staticClass: "tabs-container"
  }, [_c('tab-selector', {
    staticClass: "tabs",
    attrs: {
      "tabs-data": _vm.filters
    },
    on: {
      "change": _vm.onTabChanged
    }
  })], 1), _vm._v(" "), (!_vm.orders) ? _c('page-loader') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('search-result.orders-count', {
    count: _vm.orders.length
  })))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [_c('div', {
    staticClass: "filters"
  }, [(_vm.filterKeywords.length > 0) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('search.label.keywords')))]), _vm._v(" \"" + _vm._s(_vm.filterKeywords) + "\";")]) : _vm._e(), _vm._v(" "), (_vm.filterStatus.length > 0) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('search.label.status')))]), _vm._v(" \"" + _vm._s(_vm.filterStatus) + "\";")]) : _vm._e(), _vm._v(" "), (_vm.filterFlags.length > 0) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('search.label.notification')))]), _vm._v(" \"" + _vm._s(_vm.filterFlags) + "\";")]) : _vm._e(), _vm._v(" "), (_vm.filterPeriod.length > 0) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('search.label.period')))]), _vm._v(" \"" + _vm._s(_vm.filterPeriod) + "\"")]) : _vm._e()])])]), _vm._v(" "), _c('ul', {
    staticClass: "order-list"
  }, _vm._l((_vm.orders), function(order) {
    return _c("order-list-item", {
      key: order.number,
      tag: "li",
      attrs: {
        "order-number": order.number,
        "order-ref": order.ref,
        "order-date": order.date,
        "order-status": order.status,
        "delivery-date-from": order.delivery.fromDate,
        "delivery-date-to": order.delivery.toDate,
        "delivery-date-is-different": order.delivery.dateIsDifferent,
        "delivery-date-has-changed": order.delivery.dateHasChanged
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4507742a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageOrderList.vue
// module id = 297
// module chunks = 2